export default __webpack_public_path__ + "static/media/leader_notes_detailed.059bc443.pdf";